/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { FormattedMessage, useIntl } from 'react-intl'
import { Badge, Table } from '@mantine/core'
import SelectableRow from '../../../client/js/components/selection/SelectableRow'
import { getUserLink } from '../lib/userLinks'
import { getRoleLink } from '../../role/lib/roleLinks'
import AnchorLink from '../../../client/js/components/AnchorLink'

export type UserListItemProps = {
  item: User
}

function UserListItem (props: UserListItemProps) {
  const intl = useIntl()
  const { item } = props
  return (
    <SelectableRow value={item.id}>
      <Table.Td>
        <AnchorLink to={getUserLink(item.id)}>
          {item.username}
        </AnchorLink>
      </Table.Td>
      <Table.Td>
        {item.roleId
          ? <AnchorLink to={getRoleLink(item.roleId)}>
            {item.Role?.name}
          </AnchorLink>
          : null}
      </Table.Td>
      <Table.Td>
        {item.enabled
          ? <Badge color="green">
            <FormattedMessage
              id="enabled"
              defaultMessage="Activé"
            />
          </Badge>
          : <Badge color="gray">
            <FormattedMessage
              id="disabled"
              defaultMessage="Désactivé"
            />
          </Badge>
        }
      </Table.Td>
      <Table.Td>
        {`${intl.formatDate(item.createdAt)} ${intl.formatTime(item.createdAt)}`}
      </Table.Td>
    </SelectableRow>
  )
}

export default UserListItem
